module.exports = __webpack_public_path__ + "06_bob_gold.b27770aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/06_bob_gold.png
// module id = EFrW
// module chunks = 0